import metaSo from "stores/metadata";
import { AlarmKind, AlarmRow } from "./types";
import { ALARM_ANALOG_TYPE, ALARM_DIGITAL_TYPE } from "./alarmsTypes";



/**
 * nome della variabile PLC di una proprietà di un allarme:
 * es. ("DAL", "001", "Used") -> "DAL001_Used"
 */
export function getAlarmVarName(kind: AlarmKind, index: string, property: string): string {
	return `${kind}${index}_${property}`
}

/** parsing del nome variabile: "AAL006_Used" -> { prefix:"AAL", index:"006", property:"Used" } */
export function parseAlarmVarName(
	name: string
): { prefix: AlarmKind, index: string, property: string } | null {
	if (!name) return null
	const match = name.match(/^(AAL|DAL)(\d+)_(.+)$/)
	if (!match) return null
	return {
		prefix: match[1] as AlarmKind,
		index: match[2],
		property: match[3],
	}
}

/**
 * Raggruppa le variabili UDT_ALLARME di un componente per INDEX:
 * ogni INDEX è un tipo di allarme e corrisponde ad una riga della tabella SETTINGS.
 */
export function getAlarmRows(service: string, kind: AlarmKind): AlarmRow[] {
	if (!service || !(metaSo.state.metadata?.length > 0)) return []
	const byIndex: { [index: string]: AlarmRow } = {}
	const types = kind == "AAL" ? ALARM_ANALOG_TYPE : ALARM_DIGITAL_TYPE
	for (const meta of metaSo.state.metadata) {
		if (meta.group != "UDT_ALLARME" || meta.serviceCode != service) continue
		const parsed = parseAlarmVarName(meta.name)
		if (!parsed || parsed.prefix != kind) continue
		let row = byIndex[parsed.index]
		if (!row) {
			row = { 
				index: parsed.index, 
				typeName: types[parsed.index] ?? parsed.index,
				props: {} 
			}
			byIndex[parsed.index] = row
		}
		row.props[parsed.property] = meta
	}
	return Object.values(byIndex).sort((a, b) => a.index.localeCompare(b.index))
}

/** nome della variabile PLC che effettua l'ACK/RESET di un allarme: es. ("AAL","006") -> "AAL006_fAlarm_ACK" */
export function getAlarmAckVarName(kind: AlarmKind, index: string): string {
	return getAlarmVarName(kind, index, "fAlarm_ACK")
}
